import { Component, OnInit,Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {helpService} from '../../services/help.service';

import Swal from 'sweetalert2'

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  isLoading: boolean = false;
  feedbackForm: FormGroup;
  @Input() idRespuesta: string;
  buttomSave: any;
  ConValoracion: boolean = false;
  feedbackcompleto: boolean = false;

  constructor(private apiRest: helpService,private fb: FormBuilder) { }

  ngOnInit(): void {
    this.crearFormulario();
  }



  crearFormulario() {
    this.feedbackForm = this.fb.group({
      comentario: [null, [Validators.maxLength(350), Validators.required]],
      esLike: [null, Validators.required],
      respuestaId: [this.idRespuesta]
    })
  }

  get feedbackNoValido() {
    return this.feedbackForm.get('esLike').invalid && this.feedbackForm.get('esLike').touched;
  }

  get comentarioNoValido() {
    return this.feedbackForm.get('comentario').invalid && this.feedbackForm.get('comentario').touched;
  }

  setSaving(element){
    this.buttomSave=element;
  }

  guardarSiNo(element){
    this.apiRest.GuardarSiNo(element.value,this.idRespuesta)
    .subscribe({
      next: data => {
        this.ConValoracion= true;
      },
      error: error => {
        Swal.fire({
          title: 'No se pudo guardar el feedback',
          text: `Ocurrio un error por favor intentarlo mas tarde.`,
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
      });
  }

  guardarfeedback() {
    this.isLoading = true;

    if (this.feedbackForm.invalid){
      Object.values(this.feedbackForm.controls).forEach(control =>{
        control.markAsTouched();
      });
      this.isLoading = false;
      return;
    }

    this.buttomSave.disabled = true;
    this.buttomSave.textContent = "Guardando";
    let timerInterval
    this.apiRest.crearfeedback(this.feedbackForm.getRawValue())
    .subscribe({
      next: data => {
        this.isLoading = false;
        this.buttomSave.disabled = false;
        this.buttomSave.textContent = "Enviar";
        this.feedbackcompleto= true;
        /*Swal.fire({
          title: 'El feedback fue registrado',
          text: `Gracias por dejar sus comentarios.`,
          icon: 'success',
          timer: 1500,
          timerProgressBar: true,
          willClose: () => {
            clearInterval(timerInterval)
          },
          didOpen: () => {
            Swal.showLoading()
            const b = Swal.getHtmlContainer().querySelector('b')
            timerInterval = setInterval(() => {
              if (b){
                b.textContent = Swal.getTimerLeft()?.toString()
              }
            }, 100)
          }
        })*/
      },
      error: error => {
        console.log(error);
        this.isLoading = false;
        this.buttomSave.disabled = false;
        this.buttomSave.textContent = "Enviar";
        Swal.fire({
          title: 'No se pudo guardar el feedback',
          text: `Ocurrió un error por favor intentarlo mas tarde.`,
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
      });
  }

}
